<script>
    import {onMount, onDestroy, createEventDispatcher} from "svelte";
    export let celebrant = 'all'
    import {reservation, steps} from '../stores/reservation-store';
    import {
        i18n,
    } from "svelte-translate";

    const dispatch = createEventDispatcher();
    let minCelebrantAge;
    let maxCelebrantAge;
    // if ($reservation.eventType === "KOparty-Birthday") {
    //     minCelebrantAge = 10;
    //     maxCelebrantAge = 99;
    // } else if ($reservation.eventType === "KOmini-Birthday") {
    //     minCelebrantAge = 4;
    //     maxCelebrantAge = 5;
    // } else {
        minCelebrantAge = 2;
        maxCelebrantAge = 99;
    // }
    onMount(async () => {
        $steps.nextStepAllowed = !!document.getElementById("celebrants-form").checkValidity();
        let celebrantFieldset = document.querySelectorAll(".Celebrant")
        let f = function () {
            this.classList.add('touched')
        }
        celebrantFieldset.forEach(
             (fieldSet) => {
                fieldSet.querySelectorAll('input')
                    .forEach((e) => {
                        e.addEventListener('blur', f, false)
                        e.addEventListener('keydown', f, false)
                    })
            }
        );
    });

    // onDestroy(()=> {dispatch('celebrantRemoved', celebrant.id)});

    const removeCelebrant = () => {
        dispatch('celebrantRemoved', celebrant.id);
        $reservation.celebrants = $reservation.celebrants.filter((item) => item.id !== celebrant.id);
    }

    const checkField = (field) => {
        field.target.checkValidity();
    }
</script>
<fieldset class="Celebrant">
    <legend use:i18n={"celebrantLabel"}>Person celebrating their birthday</legend>
    <div class="Celebrant-close">
        {#if $reservation.celebrants.length > 1}<a href="#close" on:click|preventDefault={removeCelebrant}>
            <svg width="18px" height="16px" viewBox="0 0 18 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>remove</title>
                <g id="celebrant-close" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="window-close" fill="#073BB0" fill-rule="nonzero">
                        <path d="M16.3125,0 L1.6875,0 C0.755859375,0 0,0.755859375 0,1.6875 L0,14.0625 C0,14.9941406 0.755859375,15.75 1.6875,15.75 L16.3125,15.75 C17.2441406,15.75 18,14.9941406 18,14.0625 L18,1.6875 C18,0.755859375 17.2441406,0 16.3125,0 Z M16.875,14.0625 C16.875,14.371875 16.621875,14.625 16.3125,14.625 L1.6875,14.625 C1.378125,14.625 1.125,14.371875 1.125,14.0625 L1.125,1.6875 C1.125,1.378125 1.378125,1.125 1.6875,1.125 L16.3125,1.125 C16.621875,1.125 16.875,1.378125 16.875,1.6875 L16.875,14.0625 Z M12.2554688,5.49492187 L9.87539062,7.875 L12.2554687,10.2550781 C12.4171875,10.4167969 12.4171875,10.6769531 12.2554687,10.8386719 L11.9636719,11.1304688 C11.8019531,11.2921875 11.5417969,11.2921875 11.3800781,11.1304688 L9,8.75039062 L6.61992188,11.1304687 C6.45820313,11.2921875 6.19804688,11.2921875 6.03632813,11.1304687 L5.74453125,10.8386719 C5.5828125,10.6769531 5.5828125,10.4167969 5.74453125,10.2550781 L8.12460938,7.875 L5.74453125,5.49492187 C5.5828125,5.33320312 5.5828125,5.07304687 5.74453125,4.91132812 L6.03632813,4.61953125 C6.19804688,4.4578125 6.45820313,4.4578125 6.61992188,4.61953125 L9,6.99960937 L11.3800781,4.61953125 C11.5417969,4.4578125 11.8019531,4.4578125 11.9636719,4.61953125 L12.2554688,4.91132812 C12.4136719,5.07304687 12.4136719,5.33320312 12.2554688,5.49492187 L12.2554688,5.49492187 Z"
                              id="Shape"></path>
                    </g>
                </g>
            </svg>
        </a>{/if}
    </div>
    <input type="hidden" bind:value={celebrant.id}/>
    <div class="Celebrant-item">
        <label use:i18n={"celebrantNameLabel"} for="ID{celebrant.id}_celebrant_name">First name: </label>
        <input type="text" name="ID{celebrant.id}_celebrant_name" id="ID{celebrant.id}_celebrant_name"
               bind:value={celebrant.name} required/>
    </div>
    <div class="Celebrant-item">
        <label use:i18n={"celebrantAgeLabel"} for="ID{celebrant.id}_celebrant_age">Age: </label>
        <input type="number" name="ID{celebrant.id}_celebrant_age" id="ID{celebrant.id}_celebrant_age"
               bind:value={celebrant.age} min="{minCelebrantAge}" max="{maxCelebrantAge}" class="celebrant_age" on:blur={checkField} required aria-describedby="age-help" />
    </div>
    <div class="help-block" id="age-help">{#if $reservation.eventType === "KOparty-Birthday"}<span use:i18n={"birthdayAgeParty"}>Minimum 6 ans.</span>{:else if $reservation.eventType === "KOmini-Birthday"}<span use:i18n={"birthdayAgeMini"}>Entre 4 et 5 ans.</span>{:else}<span use:i18n={"birthdayAgeStandard"}>Minimum 6 ans.</span>{/if}</div>
    <div class="Celebrant-item">
        <label use:i18n={"celebrantGenderLabel"} for="ID{celebrant.id}_celebrant_gender">Gender: </label>
        <select bind:value={celebrant.gender} name="ID{celebrant.id}_celebrant_gender"
                id="ID{celebrant.id}_celebrant_gender" required>
            <option value="" use:i18n={"celebrantSelectEmpty"}>-- select gender --</option>
            <option value="m" use:i18n={"celebrantSelectBoy"}>Boy</option>
            <option value="f" use:i18n={"celebrantSelectGirl"}>Girl</option>
        </select>
    </div>
</fieldset>
